import {JBOptInReminderHeaderOuterFrameMrGreenBox} from "./jb-optin-reminder-header-outer-frame.mrgreen.box";

export const JbOptinReminderHeaderOuterFrameMrgreenCisBox = JBOptInReminderHeaderOuterFrameMrGreenBox;